import { render } from "./BlogOnLaysBenefits.vue?vue&type=template&id=707c02d6"
import script from "./BlogOnLaysBenefits.vue?vue&type=script&lang=js"
export * from "./BlogOnLaysBenefits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__